import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { authorizeOrRedirect } from 'hb4e-ui-authentication'
import { CoreConstants } from 'hb4e-ui-core'

import ListView from './components/ListView/ListView'

const { PERM_VIEW_LIST } = CoreConstants

const AuthorizedListView = authorizeOrRedirect([PERM_VIEW_LIST])(ListView)

export default () => {
  return (
    <Routes>
      <Route index element={<AuthorizedListView />} />

      {/* Additional routing is done inside the <ListView /> component */}
      <Route path="/:listID" element={<AuthorizedListView />} />
    </Routes>
  )
}
